import React from "react";
import { DatePicker as Picker } from "antd";

export default function DatePicker({ onDatePick, value, defaultDate, size }) {
  return (
    <Picker
      showTime={{ format: "HH" }}
      format="YYYY-MM-DD HH"
      onOk={onDatePick}
      value={value}
      defaultValue={defaultDate}
      size={size}
    />
  );
}
